module.exports = __WEBPACK_EXTERNAL_MODULE_175__;


//////////////////
// WEBPACK FOOTER
// external "i18next"
// module id = 175
// module chunks = 0